export function Waveform({ active = false, color = "text-slate-500", bars = 5 }) {
  return (
    <span className={`wave ${active ? "animate" : ""} ${color}`}>
      {Array.from({ length: bars }).map((_, i) => <span key={i} />)}
    </span>
  );
}
